import { FC } from 'react'

import { Knob, Track } from './styles'

export interface SwitchProps {
  checked: boolean
  onChange: (checked: boolean) => void
  disabled?: boolean
  className?: string
  id?: string
  'aria-label'?: string
}

export const Switch: FC<SwitchProps> = ({
  checked,
  onChange,
  disabled,
  className,
  id,
  'aria-label': ariaLabel,
}) => (
  <Track
    type='button'
    role='switch'
    id={id}
    aria-label={ariaLabel}
    aria-checked={checked}
    disabled={disabled}
    className={className}
    $checked={checked}
    onClick={() => onChange(!checked)}
  >
    <Knob $checked={checked} />
  </Track>
)
